import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import your translations
import en from './locales/en/translation.json';
import he from './locales/he/translation.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      he: { translation: he },
    },
    fallbackLng: 'en',
    returnNull: false,
    returnObjects: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['path','localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;